import { lazy } from "react";

// Lazy load all user views
const Home = lazy(() => import("@/views/user/Home"));
const Products = lazy(() => import("@/views/user/Products"));
const ProductDetail = lazy(() => import("@/views/user/ProductDetail"));
const Cart = lazy(() => import("@/views/user/Cart"));
const Checkout = lazy(() => import("@/views/user/Checkout"));
const Profile = lazy(() => import("@/views/user/Profile"));
const Wishlist = lazy(() => import("@/views/user/Wishlist"));
const About = lazy(() => import("@/views/user/About"));
const Contact = lazy(() => import("@/views/user/Contact"));
const Policy = lazy(() => import("@/views/user/Policy"));
const TermsAndConditions = lazy(() => import("@/views/user/TnC"));
// const FindYourRudraksha = lazy(() => import("@/views/user/FindYourRudraksha"));
// const CustomStudio = lazy(() => import("@/views/user/CustomStudio"));
const RudrakshaGuide = lazy(() => import("@/views/user/RudrakshaGuide"));

/**
 * User Routes Configuration
 * Each route object contains:
 * - path: URL path
 * - element: Component to render
 * - protected: Whether route requires authentication
 * - title: Page title for SEO
 */
export const userRoutes = [
  {
    path: "/",
    element: Home,
    protected: false,
    title: "Home - Subrahmanya Rudraksha",
  },
  {
    path: "/product",
    element: Products,
    protected: false,
    title: "Products - Subrahmanya Rudraksha",
  },
  {
    path: "/product/:categoryId/:subCategoryId",
    element: Products,
    protected: false,
    title: "Products - Subrahmanya Rudraksha",
  },
  {
    path: "/product/:categoryId",
    element: Products,
    protected: false,
    title: "Products - Subrahmanya Rudraksha",
  },
  {
    path: "/product/:categoryId/:subCategoryId/:id",
    element: ProductDetail,
    protected: false,
    title: "Product Details - Subrahmanya Rudraksha",
  },
  {
    path: "/cart",
    element: Cart,
    protected: false,
    title: "Shopping Cart - Subrahmanya Rudraksha",
  },
  {
    path: "/cart/checkout",
    element: Checkout,
    protected: true,
    title: "Checkout - Subrahmanya Rudraksha",
  },
  {
    path: "/my-account/*",
    element: Profile,
    protected: true,
    title: "My Account - Subrahmanya Rudraksha",
  },
  // {
  //   path: "/orders",
  //   element: Orders,
  //   protected: true,
  //   title: "My Orders - Subrahmanya Rudraksha",
  // },
  {
    path: "/wishlist",
    element: Wishlist,
    protected: true,
    title: "Wishlist - Subrahmanya Rudraksha",
  },
  {
    path: "/about",
    element: About,
    protected: false,
    title: "About Us - Subrahmanya Rudraksha",
  },
  // {
  //   path: "/find-your-rudraksha",
  //   element: FindYourRudraksha,
  //   protected: false,
  //   title: "Find Your Rudraksha - Subrahmanya Rudraksha",
  // },
  // {
  //   path: "/custom-studio",
  //   element: CustomStudio,
  //   protected: false,
  //   title: "Custom Studio - Subrahmanya Rudraksha",
  // },
  {
    path: "/rudraksha",
    element: RudrakshaGuide,
    protected: false,
    title: "Rudraksha - Subrahmanya Rudraksha",
  },
  {
    path: "/contact",
    element: Contact,
    protected: false,
    title: "Contact Us - Subrahmanya Rudraksha",
  },
  {
    path: "/privacy-policy",
    element: Policy,
    protected: false,
    title: "Privacy Policy - Subrahmanya Rudraksha",
  },
  {
    path: "/terms-of-use",
    element: TermsAndConditions,
    protected: false,
    title: "Terms of Use - Subrahmanya Rudraksha",
  },
];

export default userRoutes;
